import { useState } from 'react';
import { tokens } from '../tokens';
import Hero from './Hero';
import ProfitChart from './ProfitChart';
import Config from './Config';
import Statistics from './Statistics';
import LiveState from './LiveState';
import TransactionList from './TransactionList';
import { DEFAULT_TX_FILTERS, TxFilters } from './TransactionList/FilterRow';
import Masthead from './shared/Masthead';

const Result = () => {
  const [txFilters, setTxFilters] = useState<TxFilters>(DEFAULT_TX_FILTERS);
  return (
    <div
      style={{
        background: tokens.backgroundBase,
        color: tokens.textPrimary,
        fontFamily: tokens.fontSans,
        width: '100%',
        padding: 16,
        marginTop: 24,
        paddingRight: 32,
        paddingLeft: 32,
        boxSizing: 'border-box',
      }}
    >
      <Masthead />
      <ProfitChart />
      <Hero />
      <Config />
      <Statistics />
      <LiveState filters={txFilters} onFiltersChange={setTxFilters} />
      <TransactionList filters={txFilters} />
      <div style={{ height: 32 }} />
    </div>
  );
};

export default Result;
